module.exports = __webpack_public_path__ + "static/img/mobile.fbfcce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/mobile.png
// module id = /BSy
// module chunks = 0